/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import { AppFooterFragmentDoc } from '../components/organisms/AppFooter/AppFooter.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type FetchErrorLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchErrorLayoutQuery = { terms: Array<{ type: Types.TermType, title: string }> };


export const FetchErrorLayoutDocument = gql`
    query FetchErrorLayout {
  ...AppFooter
}
    ${AppFooterFragmentDoc}`;

/**
 * __useFetchErrorLayoutQuery__
 *
 * To run a query within a Vue component, call `useFetchErrorLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchErrorLayoutQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchErrorLayoutQuery();
 */
export function useFetchErrorLayoutQuery(options: VueApolloComposable.UseQueryOptions<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>(FetchErrorLayoutDocument, {}, options);
}
export function useFetchErrorLayoutLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>(FetchErrorLayoutDocument, {}, options);
}
export type FetchErrorLayoutQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchErrorLayoutQuery, FetchErrorLayoutQueryVariables>;